/* app/controls/control.properties-rotator */

import $ from 'jquery';

import Flickity from 'flickity';
import 'flickity-as-nav-for';
import 'flickity-fade';
import 'flickity-imagesloaded';

import { subscribe } from 'Util/pubsub';

let $featuredarticleRotators = [];

const featuredArticlesRotatorSettings = {
	wrapAround: false,
	lazyLoad: true,
	pageDots: false,
	contain: true,
	cellAlign: 'left',
	prevNextButtons: false
};

var FeaturedArticleRotator = {
	init: function ($elms) {
		$featuredarticleRotators = $elms;

		if ($featuredarticleRotators.length) {
			FeaturedArticleRotator._initFlickity();
			subscribe('/window/resize', FeaturedArticleRotator._initFlickity);
		}
	},

	_initFlickity: function () {

		for (let i = 0; i < $featuredarticleRotators.length; i++) {

			var $rotator = $($featuredarticleRotators[i]);
			var width = $rotator[0].offsetWidth;
			if (width < 940) {
				var flkty = new Flickity($rotator[0], featuredArticlesRotatorSettings);
				$rotator.data('flickity-instance', flkty);
			} else {
				var flkty = $rotator.data('flickity-instance');
				if (flkty) {
					flkty.destroy();
				}
			}
		}
	}
};

export { FeaturedArticleRotator };
